// Utility function to order posts
export default {
  methods: {
    order(array, order, key) {
      array.sort(function (a, b) {
        const A = a[key]
        const B = b[key]

        if (order.indexOf(A) > order.indexOf(B)) {
          return 1
        }
        return -1
      })
      return array
    }
  }
}
